import { NgModule, Injectable } from "@angular/core";
import { MatStepperModule } from "@angular/material/stepper";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatRadioModule } from "@angular/material/radio";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AlertModule } from "ngx-bootstrap/alert";
import { ClipboardModule } from "ngx-clipboard";
import { ModalModule } from "ngx-bootstrap/modal";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Dialog, DialogModule } from "primeng/dialog";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { CalendarModule } from 'primeng/calendar';

// own components
import { SpinnerComponent } from "./spinner/spinner.component";
import { SideBarComponent } from "./side-bar/side-bar.component";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { FilterComponent } from "./components/filter/filter.component";
import { BadgesComponent } from "./components/badges/badges.component";
import { TabsModule } from "ngx-bootstrap/tabs";
import { NgSelectModule } from "@ng-select/ng-select";
import { DepositePreviewComponent } from "./modules/deposite/deposite-preview/deposite-preview.component";
import { DepositeInventoryChangesPreviewComponent } from "./modules/deposite/deposite-inventory-changes-preview/deposite-inventory-changes-preview.component";
import { DepositeInventoryPreviewComponent } from "./modules/deposite/deposite-inventory-preview/deposite-inventory-preview.component";
import { DepositeInventoryNoteComponent } from "./modules/deposite/deposite-inventory-note/deposite-inventory-note.component";
import { ControlSelectComponent } from "./components/controls/control-select/control-select.component";
import { ControlTextInputComponent } from "./components/controls/control-text-input/control-text-input.component";
import { ControlTextEmailComponent } from "./components/controls/control-email-input/control-email-input.component";
import { ControlNumberInputComponent } from "./components/controls/control-number-input/control-number-input.component";
import { ControlTextPlaceholderInputComponent } from "./components/controls/control-text-placeholder-input/control-text-placeholder-input.component";

import { ControlDateInputComponent } from "./components/controls/control-date-input/control-date-input.component";
import { ControlDateTimeInputComponent } from "./components/controls/control-date-time-input/control-date-time-input.component";
import { ControlCheckBoxInputComponent } from "./components/controls/control-checkbox-input/control-checkbox-input.component";
import { ControlSwitchInputComponent } from "./components/controls/control-switch-input/control-switch-input.component";
import { ControlTextAreaComponent } from "./components/controls/control-textarea/control-textarea.component";
import { CarSelectComponent } from "./modules/car/car-select/car-select.component";
import { CarDepositeItemComponent } from "./modules/car/car-deposite-item/car-deposite-item.component";
import { CarNotePreviewListComponent } from "./modules/car/car-note-preview-list/car-note-preview-list.component";
import { TyreSelectComponent } from "./modules/tyre/tyre-select/tyre-select.component";
import { TyreStatePreviewListComponent } from "./modules/tyre-state/tyre-state-preview-list/tyre-state-preview-list.component";
import { IntegratedTyreStatePreviewListComponent } from "./modules/tyre-state/integrated-tyre-state-preview-list/integrated-tyre-state-preview-list.component";
import { IntegratedTyreStatePreviewListSidePanelComponent } from "./modules/tyre-state/integrated-tyre-state-preview-list-side-panel/integrated-tyre-state-preview-list-side-panel.component";
import { OrderCarPreviewListComponent } from "./modules/order/order-car-preview-list/order-car-preview-list.component";
import { TyreTakeoverOrderDepositeComponent } from "./modules/tyre-takeover-order/tyre-takeover-order-deposite/tyre-takeover-order-deposite.component";
import { AddressesDictionaryComponent } from "./modules/addresses-dictionary/addresses-dictionary-select/addresses-dictionary-select.component";
import { RelocationTakeoverDepositeComponent } from "./modules/relocation-order/relocation-takeover-deposite/relocation-takeover-deposite.component";
import { RelocationTakeoverDepositeNewComponent } from "./modules/relocation-order/relocation-takeover-deposite-new/relocation-takeover-deposite-new.component";
import { RelocationDepositeListComponent } from "./modules/relocation-order/relocation-deposite-list/relocation-deposite-list.component";

import { ControlTextTelephoneComponent } from "./components/controls/control-telephone-input/control-telephone-input.component";
import { ControlPostalCodeComponent } from "./components/controls/control-postalcode-input/control-postalcode-input.component";
import { ControlNIPComponent } from "./components/controls/control-nip-input/control-nip-input.component";

import { SpecificationDepositesComponent } from "./modules/specification/specification-deposites/specification-deposites.component";
import { SpecificationDepositesDialogComponent } from "./modules/specification/specification-deposites-dialog/specification-deposites-dialog.component";
import { SpecificationDepositePreviewComponent } from "./modules/specification/specification-deposite-preview/specification-deposite-preview.component";
import { SpecificationCarTyrestatesPreviewComponent } from "./modules/specification/specification-car-tyrestates-preview/specification-car-tyrestates-preview.component";
import { ControlHeightTreadInputComponent } from "./components/controls/control-height-tread-input/control-height-tread-input.component";
import { ControlTextDOTComponent } from "./components/controls/control-dot-input/control-dot-input.component";
import { SpecificationTyreStatePreviewComponent } from "./modules/specification/specification-tyre-state-preview/specification-tyre-state-preview.component";
import { SpecificationTyreStateComponent } from "./modules/specification/specification-tyre-state/specification-tyre-state.component";
import { SpecificationServicesComponent } from "./modules/specification/specification-services/specification-services.component";
import { SpecificationNotePreviewListComponent } from "./modules/specification/specification-note-preview-list/specification-note-preview-list.component";
import { SpecificationDetailNotePreviewListComponent } from "./modules/specification/specification-detail-note-preview-list/specification-detail-note-preview-list.component";

import { GarageVisitDepositeListComponent } from "./modules/garage-visits/garage-visits-deposite-list/garage-visits-deposite-list.component";
import { GarageVisitTyreOrderListComponent } from "./modules/garage-visits/garage-visits-tyre-order-list/garage-visits-tyre-order-list.component";
import { GarageVisitsAppointmentsSelectComponent } from "./modules/garage-visits/garage-visits-appointments-select-dialog/garage-visits-appointments-select-dialog.component";

import { UploadFileComponent } from "./components/upload-file/upload-file.component"


import { CustomMinDirective } from "../directives/custom-min-validator.directive";
import { CustomMaxDirective } from "../directives/custom-max-validator.directive";


import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OwlDateTimeIntl,
  OWL_DATE_TIME_LOCALE,
} from "ng-pick-datetime";

import { TyreSupplierOffersPreviewComponent } from "./modules/tyre/tyre-supplier-offers-preview/tyre-supplier-offers-preview.component";
import { OrderNotePreviewListComponent } from "./modules/order/order-note-preview-list/order-note-preview-list.component";
import { GarageOrderNotePreviewListComponent } from "./modules/garage-order/garage-order-note-preview-list/garage-order-note-preview-list.component";

import { MessagePreviewComponent } from "./modules/message/message-preview/message-preview.component";
import { MessagePreviewDialogComponent } from "./modules/message/message-preview-dialog/message-preview-dialog.component";

import { TooltipModule } from "ngx-bootstrap/tooltip";
import { AutofocusFixModule } from "ngx-autofocus-fix";
import { TabViewModule } from 'primeng/tabView';
import { PrimeNGConfig, Translation } from 'primeng/api';

import { BsDatepickerModule, BsLocaleService } from "ngx-bootstrap/datepicker";
import { defineLocale } from "ngx-bootstrap/chronos";
import { plLocale } from "ngx-bootstrap/locale";
defineLocale("pl", plLocale);

const primeNgPolishTranslation: Translation = {
  startsWith: 'Zaczyna się od',
  contains: 'Zawiera',
  notContains: 'Nie zawiera',
  endsWith: 'Kończy się na',
  equals: 'Równa się',
  notEquals: 'Nie równa się',
  noFilter: 'Bez filtra',
  lt: 'Mniejsze niż',
  lte: 'Mniejsze lub równe',
  gt: 'Większe niż',
  gte: 'Większe lub równe',
  is: 'Jest',
  isNot: 'Nie jest',
  before: 'Przed',
  after: 'Po',
  dateIs: 'Data równa',
  dateIsNot: 'Data różna',
  dateBefore: 'Data przed',
  dateAfter: 'Data po',
  clear: 'Wyczyść',
  apply: 'Zastosuj',
  matchAll: 'Dopasuj wszystkie',
  matchAny: 'Dopasuj dowolne',
  addRule: 'Dodaj regułę',
  removeRule: 'Usuń regułę',
  accept: 'Tak',
  reject: 'Nie',
  choose: 'Wybierz',
  upload: 'Wgraj',
  cancel: 'Anuluj',
  dayNames: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
  dayNamesShort: ['Nie', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'],
  dayNamesMin: ['Nie', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'],
  monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
  monthNamesShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
  today: 'Dzisiaj',
  weekHeader: 'Tyg',
  weak: 'Słabe',
  medium: 'Średnie',
  strong: 'Mocne',
  passwordPrompt: 'Wprowadź hasło',
  emptyMessage: 'Brak wyników',
  emptyFilterMessage: 'Brak wyników'
};

// 3rd party
import { KeyFilterModule } from 'primeng/keyfilter';
import { SidebarModule } from "primeng/sidebar";
import { FormPanelComponent } from "./components/form-panel/form-panel.component";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { OrderNotePreviewComponent } from "./modules/order/order-note-preview/order-note-preview.component";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { ControlPasswordInputComponent } from "./components/controls/control-password-input/control-password-input.component";
import { ControlDateRangeInputComponent } from "./components/controls/control-date-range-input/control-date-range-input.component";
import { ControlDateSingleInputComponent } from "./components/controls/control-date-single-input/control-date-single-input.component";
import { ControlInlineActionComponent } from "./components/controls/control-inline-action/control-inline-action.component";
import { SpinnerFullBlockComponent } from "./spinner-full-block/spinner-full-block.component";
import { ControlMaskInputComponent } from "./components/controls/control-mask-input/control-mask-input.component";
import { ControlKeyFilterInputComponent } from "./components/controls/control-key-filter-input/control-key-filter-input.component";
import { InputPromptComponent } from "./components/controls/input-prompt/input-prompt.component";

import { CarImportPanelComponent } from "./modules/car/car-import-panel/car-import-panel.component";
import { ImportPanelComponent } from "./import-panel/import-panel.component";
import { DashboardNewsComponent } from "./modules/dashboard/dashboard-news/dashboard-news.component";
import { DashboardVideoComponent } from "./modules/dashboard/dashboard-video/dashboard-video.component";
import { DashboardArticleComponent } from "./modules/dashboard/dashboard-article/dashboard-article.component";
import { CarouselModule } from 'primeng/carousel';
import { DashboardPanelComponent } from "./modules/dashboard/dashboard-panel/dashboard-panel.component";
import { DashboardWidgetComponent } from "./modules/dashboard/dashboard-widget/dashboard-widget.component";
import { DashboardWidgetFilesComponent } from "./modules/dashboard/dashboard-widget/dashboard-widget-files/dashboard-widget-files.component";
import { ChartsModule } from 'ng2-charts';
import { CardModule } from "primeng/card";


@Injectable()
export class DefaultIntl extends OwlDateTimeIntl {
  /** A label for the up second button (used by screen readers).  */
  public upSecondLabel = 'Dodaj sekunde';

  /** A label for the down second button (used by screen readers).  */
  public downSecondLabel = 'Odejmij sekunde';

  /** A label for the up minute button (used by screen readers).  */
  public upMinuteLabel = 'Dodaj minutę';

  /** A label for the down minute button (used by screen readers).  */
  public downMinuteLabel = 'Odejmij minutę';

  /** A label for the up hour button (used by screen readers).  */
  public upHourLabel = 'Ddodaj godzinę';

  /** A label for the down hour button (used by screen readers).  */
  public downHourLabel = 'Odejmij godzinę';

  /** A label for the previous month button (used by screen readers). */
  public prevMonthLabel = 'Poprzedni miesiąc';

  /** A label for the next month button (used by screen readers). */
  public nextMonthLabel = 'Następny miesiąc';

  /** A label for the previous year button (used by screen readers). */
  public prevYearLabel = 'Poprzedni rok';

  /** A label for the next year button (used by screen readers). */
  public nextYearLabel = 'Następny rok';

  /** A label for the previous multi-year button (used by screen readers). */
  public prevMultiYearLabel = 'Poprzednie 21 lat';

  /** A label for the next multi-year button (used by screen readers). */
  public nextMultiYearLabel = 'Nastęne 21 lat';

  /** A label for the 'switch to month view' button (used by screen readers). */
  public switchToMonthViewLabel = 'Zmień na widok miesięcy';

  /** A label for the 'switch to year view' button (used by screen readers). */
  public switchToMultiYearViewLabel = 'Wybierz miesiąc i rok';

  /** A label for the cancel button */
  public cancelBtnLabel = 'Anuluj';

  /** A label for the set button */
  public setBtnLabel = 'OK';

  /** A label for the range 'from' in picker info */
  public rangeFromLabel = 'Od';

  /** A label for the range 'to' in picker info */
  public rangeToLabel = 'Do';

  /** A label for the hour12 button (AM) */
  public hour12AMLabel = 'AM';

  /** A label for the hour12 button (PM) */
  public hour12PMLabel = 'PM';
};


const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    SpinnerComponent,
    SideBarComponent,
    PaginationComponent,
    FilterComponent,
    BadgesComponent,
    DepositePreviewComponent,
    DepositeInventoryPreviewComponent,
    DepositeInventoryNoteComponent,
    FormPanelComponent,
    ControlSelectComponent,
    ControlTextInputComponent,
    ControlCheckBoxInputComponent,
    ControlSwitchInputComponent,
    ControlNumberInputComponent,
    ControlDateInputComponent,
    ControlTextAreaComponent,
    ControlTextEmailComponent,
    ControlDateTimeInputComponent,
    CarSelectComponent,
    CarDepositeItemComponent,
    TyreSelectComponent,
    TyreStatePreviewListComponent,
    IntegratedTyreStatePreviewListComponent,
    IntegratedTyreStatePreviewListSidePanelComponent,
    OrderCarPreviewListComponent,
    TyreSupplierOffersPreviewComponent,
    OrderNotePreviewListComponent,
    OrderNotePreviewComponent,
    ControlDateRangeInputComponent,
    ControlDateSingleInputComponent,
    ControlInlineActionComponent,
    ControlPasswordInputComponent,
    SpinnerFullBlockComponent,
    ControlMaskInputComponent,
    ControlKeyFilterInputComponent,
    InputPromptComponent,
    DepositeInventoryChangesPreviewComponent,
    ImportPanelComponent,
    CarImportPanelComponent,
    DashboardNewsComponent,
    DashboardVideoComponent,
    DashboardArticleComponent,
    DashboardPanelComponent,
    DashboardWidgetComponent,
    DashboardWidgetFilesComponent,
    TyreTakeoverOrderDepositeComponent,
    AddressesDictionaryComponent,
    RelocationTakeoverDepositeComponent,
    RelocationTakeoverDepositeNewComponent,
    ControlTextTelephoneComponent,
    ControlPostalCodeComponent,
    SpecificationDepositesComponent,
    SpecificationDepositesDialogComponent,
    SpecificationDepositePreviewComponent,
    SpecificationCarTyrestatesPreviewComponent,
    ControlHeightTreadInputComponent,
    ControlTextDOTComponent,
    SpecificationTyreStatePreviewComponent,
    SpecificationTyreStateComponent,
    SpecificationServicesComponent,
    GarageVisitDepositeListComponent,
    GarageVisitTyreOrderListComponent,
    GarageVisitsAppointmentsSelectComponent,
    CustomMinDirective,
    CustomMaxDirective,
    RelocationDepositeListComponent,
    ControlNIPComponent,
    GarageOrderNotePreviewListComponent,
    SpecificationNotePreviewListComponent,
    SpecificationDetailNotePreviewListComponent,
    CarNotePreviewListComponent,
    MessagePreviewComponent,
    MessagePreviewDialogComponent,
    UploadFileComponent,
    ControlTextPlaceholderInputComponent
  ],
  imports: [
    CommonModule,
    SidebarModule,
    NgbModule,
    AlertModule,
    FormsModule,
    ReactiveFormsModule,
    TabsModule.forRoot(),
    ClipboardModule,
    NgSelectModule,
    NgxMaskModule.forRoot(maskConfig),
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    MatStepperModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ModalModule.forRoot(),
    AutofocusFixModule.forRoot(),
    DialogModule,
    ConfirmDialogModule,
    RouterModule,
    NgxDaterangepickerMd.forRoot(),
    KeyFilterModule,
    CarouselModule,
    TabViewModule,
    ChartsModule,
    CardModule,
    CalendarModule
  ],
  exports: [
    SpinnerComponent,
    SideBarComponent,
    PaginationComponent,
    FilterComponent,
    BadgesComponent,
    DepositePreviewComponent,
    DepositeInventoryPreviewComponent,
    DepositeInventoryNoteComponent,
    FormPanelComponent,
    ControlSelectComponent,
    ControlTextInputComponent,
    ControlCheckBoxInputComponent,
    ControlSwitchInputComponent,
    ControlNumberInputComponent,
    ControlDateInputComponent,
    ControlTextAreaComponent,
    ControlTextEmailComponent,
    ControlDateTimeInputComponent,
    CarSelectComponent,
    CarDepositeItemComponent,
    TyreSelectComponent,
    TyreStatePreviewListComponent,
    IntegratedTyreStatePreviewListComponent,
    IntegratedTyreStatePreviewListSidePanelComponent,
    OrderCarPreviewListComponent,
    OrderNotePreviewListComponent,
    OrderNotePreviewComponent,
    ControlDateRangeInputComponent,
    ControlDateSingleInputComponent,
    ControlInlineActionComponent,
    ControlPasswordInputComponent,
    SpinnerFullBlockComponent,
    ControlMaskInputComponent,
    ControlKeyFilterInputComponent,
    InputPromptComponent,
    DepositeInventoryChangesPreviewComponent,
    TyreSupplierOffersPreviewComponent,
    ImportPanelComponent,
    CarImportPanelComponent,
    DashboardNewsComponent,
    DashboardVideoComponent,
    DashboardArticleComponent,
    DashboardPanelComponent,
    DashboardWidgetComponent,
    DashboardWidgetFilesComponent,
    TyreTakeoverOrderDepositeComponent,
    AddressesDictionaryComponent,
    RelocationTakeoverDepositeComponent,
    RelocationTakeoverDepositeNewComponent,
    ControlTextTelephoneComponent,
    ControlPostalCodeComponent,
    SpecificationDepositesComponent,
    SpecificationDepositesDialogComponent,
    SpecificationDepositePreviewComponent,
    SpecificationCarTyrestatesPreviewComponent,
    ControlHeightTreadInputComponent,
    ControlTextDOTComponent,
    SpecificationTyreStatePreviewComponent,
    SpecificationTyreStateComponent,
    SpecificationServicesComponent,
    GarageVisitDepositeListComponent,
    GarageVisitTyreOrderListComponent,
    GarageVisitsAppointmentsSelectComponent,
    CustomMinDirective,
    CustomMaxDirective,
    RelocationDepositeListComponent,
    ControlNIPComponent,
    GarageOrderNotePreviewListComponent,
    SpecificationNotePreviewListComponent,
    SpecificationDetailNotePreviewListComponent,
    CarNotePreviewListComponent,
    MessagePreviewComponent,
    MessagePreviewDialogComponent,
    UploadFileComponent,
    ControlTextPlaceholderInputComponent,
    TooltipModule
  ],
  providers: [{ provide: OwlDateTimeIntl, useClass: DefaultIntl }],
})
export class SharedModule {
  constructor(private bsLocaleService: BsLocaleService, private primeNgConfig: PrimeNGConfig) {
    this.bsLocaleService.use("pl");
    this.primeNgConfig.setTranslation(primeNgPolishTranslation);
  }
}
